import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import LearnEnglishPagePatternLayout from "./LearnEnglishPagePatternLayout.vue";
import { useStore } from "vuex";
import { computed } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'Overview-page',
  setup(__props) {

const store = useStore();
const locale = computed(() => store.getters["locale/locale"]);
console.log(locale);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LearnEnglishPagePatternLayout, {
    title: 
      _ctx.$t('NAVIGATION_MENU.LANGUAGE_LEARNING_SECTION.ENGLISH_SUBMENU.OVERVIEW')
    
  }, {
    content: _withCtx(() => _cache[0] || (_cache[0] = [
      _createElementVNode("div", { id: "overview" }, [
        _createElementVNode("h1", { class: "" }, "overview")
      ], -1)
    ])),
    _: 1
  }, 8, ["title"]))
}
}

})